export function reportField(row, pascal, camel, fallback) {
  if (row == null) return fallback;
  if (Object.prototype.hasOwnProperty.call(row, pascal) && row[pascal] !== undefined && row[pascal] !== null) {
    return row[pascal];
  }
  if (Object.prototype.hasOwnProperty.call(row, camel) && row[camel] !== undefined && row[camel] !== null) {
    return row[camel];
  }
  return fallback;
}

export function reportNumber(row, pascal, camel, fallback = 0) {
  const raw = reportField(row, pascal, camel, fallback);
  const n = typeof raw === 'number' ? raw : parseFloat(raw);
  return Number.isFinite(n) ? n : fallback;
}

export function hoursFromMinutes(minutes) {
  const n = typeof minutes === 'number' ? minutes : parseFloat(minutes);
  if (!Number.isFinite(n) || n <= 0) return 0;
  return Math.round((n / 60) * 10) / 10;
}
